import React, { useState, useEffect } from "react";
import Layout from "../Component/Layout";
import { BiSearch, BiSolidTrashAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import axios from "axios";
import REACT_APP_API_URL from "../utils/constant";
import { showToast } from "../helper/Toster";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Explore = () => {
  const [explores, setExplores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate(); // add this

  useEffect(() => {
    const fetchExploreListings = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}/Explore-Listings`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("user")}`,
            },
          }
        );
        if (response.data.code === 200) {
          setExplores(response.data.data);
        }
        console.log("response", response.data);
      } catch (error) {
        console.error("Error fetching explore listings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchExploreListings();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it",
    });

    if (!confirmDelete.isConfirmed) return;

    try {
      const response = await axios.get(
        `${REACT_APP_API_URL}/delete-explore?id=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          },
        }
      );

      if (response.data.code === 200) {
        showToast("success", "Explore deleted successfully");
        setExplores((prev) => prev.filter((item) => item.id !== id));
      } else {
        showToast(response.data.message || "Failed to delete", "error");
      }
    } catch (error) {
      console.error("Error deleting explore:", error);
      showToast("error", "Error deleting explore");
    }
  };

  // Filter explores based on search term
  const filteredExplores = explores.filter((explore) =>
    explore.trip_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <Layout>
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <div className="nav-item d-flex align-items-center border rounded-2 ps-2 w-auto me-3">
                <BiSearch className="bx-md" />
                <input
                  type="text"
                  className="form-control border-0 shadow-none ps-1 ps-sm-2"
                  placeholder="Search..."
                  aria-label="Search..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  disabled
                />
              </div>
              <div className="d-flex align-items-center gap-2">
                <Link
                  to="/explore/add"
                  className="btn btn-outline-primary px-5"
                >
                  Add
                </Link>
              </div>
            </div>

            <div className="row">
              {[...Array(6)].map((_, index) => (
                <div className="col-lg-4 col-sm-6 mt-4" key={index}>
                  <div className="card h-100 position-relative">
                    <div
                      className="shimmer-bg"
                      style={{ height: "200px", borderRadius: "8px" }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <style>
          {`
                        .shimmer-bg {
                            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                            background-size: 200% 100%;
                            animation: shimmer 1.5s infinite;
                            border-radius: 4px;
                        }
                        
                        @keyframes shimmer {
                            0% { background-position: -200% 0; }
                            100% { background-position: 200% 0; }
                        }
                    `}
        </style>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="nav-item d-flex align-items-center border rounded-2 ps-2 w-auto me-3">
              <BiSearch className="bx-md" />
              <input
                type="text"
                className="form-control border-0 shadow-none ps-1 ps-sm-2"
                placeholder="Search..."
                aria-label="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="d-flex align-items-center gap-2">
              <Link to="/explore/add" className="btn btn-outline-primary px-5">
                Add
              </Link>
            </div>
          </div>

          <div className="row">
            {filteredExplores.length > 0 ? (
              filteredExplores.map((explore) => (
                <div className="col-lg-4 col-sm-6 mt-4" key={explore.id}>
                  <div className="card h-100 position-relative overflow-hidden explore-card">
                    <Link to={`/explore/detail/${explore.id}`}>
                      {explore.thumbnail && (
                        <img
                          className="card-img-top rounded-2"
                          src={explore.thumbnail}
                          alt={explore.trip_name}
                          style={{ height: "200px", objectFit: "cover" }}
                        />
                      )}
                      <div className="overlay rounded-2 d-flex align-items-center justify-content-center">
                        <h4 className="m-0 text-white">{explore.trip_name}</h4>
                      </div>
                    </Link>
                    <div
                      onClick={() => handleDelete(explore.id)}
                      className="delete-button position-absolute rounded-2"
                      style={{
                        background: "#0009",
                        padding: "7px 10px",
                        right: -40,
                        top: 10,
                      }}
                    >
                      <Link to={""}>
                        <BiSolidTrashAlt
                          className="fs-5"
                          style={{ color: "#dd1010" }}
                        />
                      </Link>
                    </div>
                    <div
                      className="category position-absolute rounded-pill py-1 px-3"
                      style={{ background: "#fff", left: 10, bottom: 10 }}
                    >
                      <p className="m-0 fw-medium" style={{ color: "#264A2E" }}>
                        {explore.category}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12">
                <div className="text-center mt-4">
                  {searchTerm.trim() !== ""
                    ? "No explores match your search criteria."
                    : "No explores found."}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Explore;
